"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Dbg_1 = require("./Dbg");
exports.RT_BINDING = Symbol("RT:BINDING");
class Binding {
    constructor(owner, prop, value, clone) {
        this.owner = owner;
        this.prop = prop;
        this.value = value;
        this.clone = clone;
    }
    readable(receiver) {
        let v = this.owner[this.prop];
        if (v === receiver) // check if array is not yet cloned
            v = this.value;
        return v;
    }
    writable(receiver) {
        let v = this.owner[this.prop];
        if (v === receiver) { // check if it's first write and clone then
            if (Dbg_1.Dbg.trace.writes)
                Dbg_1.Dbg.log("║", "", ` Copy-on-write: ${this.owner.constructor.name}.${this.prop.toString()}`);
            v = this.owner[this.prop] = this.clone(this.value);
        }
        return v;
    }
    static seal(owner, prop, value, proto, clone) {
        if (Object.isFrozen(value)) /* istanbul ignore next */
            throw new Error("copy-on-write collection cannot be referenced from multiple objects");
        const self = value;
        if (Dbg_1.Dbg.trace.writes)
            Dbg_1.Dbg.log("║", "", ` Sealing for copy-on-write: ${owner.constructor.name}.${prop.toString()}`);
        const binding = new Binding(owner, prop, value, clone);
        self[exports.RT_BINDING] = binding;
        Object.setPrototypeOf(value, proto);
        Object.freeze(value);
        return binding;
    }
}
exports.Binding = Binding;
function R(self) {
    const binding = self[exports.RT_BINDING];
    return binding !== undefined ? binding.readable(self) : self;
}
exports.R = R;
function W(self) {
    const binding = self[exports.RT_BINDING];
    return binding !== undefined ? binding.writable(self) : self;
}
exports.W = W;
